import { render } from "./ListeCategorieFaqPage.vue?vue&type=template&id=107e2f06&ts=true"
import script from "./ListeCategorieFaqPage.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieFaqPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__